import { useState, useEffect } from "react";


export default function ItemQtyModal({
  open,
  item,
  size,
  onConfirm,
  onClose
}) {
  const [qty, setQty] = useState(1);
  useEffect(() => {
  if (open) {
    setQty(1);
  }
}, [open]);

  if (!open || !item) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3 style={{ marginBottom: 10 }}>
          Quantity — {item.item_name}
        </h3>

        {size && (
          <p style={{ marginBottom: 10 }}>
            <strong>{size.size_name}</strong> — ₹{size.price}
          </p>
        )}

        <div style={qtyRow}>
          <button
            style={qtyBtn}
            onClick={() => setQty(q => Math.max(1, q - 1))}
          >
            −
          </button>

          <div style={qtyBox}>{qty}</div>

          <button
            style={qtyBtn}
            onClick={() => setQty(q => q + 1)}
          >
            +
          </button>
        </div>

        <button
          style={confirmBtn}
          onClick={() => onConfirm(qty)}
        >
          Add to Order
        </button>

        <button style={closeBtn} onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10000
};

const modalStyle = {
  background: "#fff",
  borderRadius: 10,
  padding: 20,
  width: "90%",
  maxWidth: 360,
  textAlign: "center",
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
};

const qtyRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 20,
  margin: "20px 0"
};

const qtyBtn = {
  width: 44,
  height: 44,
  fontSize: 22,
  borderRadius: 6,
  border: "1px solid #ccc",
  background: "#f5f5f5",
  cursor: "pointer"
};

const qtyBox = {
  minWidth: 50,
  fontSize: 20,
  fontWeight: "bold"
};

const confirmBtn = {
  width: "100%",
  padding: 12,
  background: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  fontSize: 16,
  cursor: "pointer",
  marginBottom: 10
};

const closeBtn = {
  width: "100%",
  padding: 10,
  background: "#b00020",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer"
};
